import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";
import { PageHero, FinalCta } from "../components/Sections";
import { SERVICES } from "../data/site";

const Services = () => {
    useEffect(() => {
        document.title = "Services | Brand Strategy, Retail, Digital & Sales Growth — ALBL Narmadapuram";
    }, []);

    useEffect(() => {
        if (window.location.hash) {
            const el = document.querySelector(window.location.hash);
            if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
        }
    }, []);

    return (
        <main>
            <PageHero
                eyebrow="Services"
                title="FROM BRAND THINKING TO SALES EXECUTION."
                sub="Five connected service areas. Every engagement is built around your business objective — not around a package."
            />

            <section className="bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28 space-y-6">
                    {SERVICES.map((s, i) => (
                        <Reveal key={s.slug} delay={i * 40}>
                            <article
                                id={s.slug}
                                data-testid={`service-detail-${i + 1}`}
                                className={`grid lg:grid-cols-12 gap-10 border border-slate-200 p-8 sm:p-12 scroll-mt-28 ${
                                    i % 2 === 1 ? "bg-[#F8FAFC]" : "bg-white"
                                }`}
                            >
                                <div className="lg:col-span-4">
                                    <span className="font-serif-accent italic text-4xl text-[#C5A059]">
                                        {s.num}
                                    </span>
                                    <h2 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-slate-900 mt-4">
                                        {s.title}
                                    </h2>
                                    <p className="mt-4 text-slate-600 text-sm sm:text-base leading-relaxed">
                                        {s.short}
                                    </p>
                                </div>
                                <div className="lg:col-span-5">
                                    <p className="text-xs tracking-[0.25em] uppercase font-semibold text-[#1E3A8A] mb-5">
                                        What it includes
                                    </p>
                                    <ul className="space-y-4">
                                        {s.details.map((d) => (
                                            <li key={d} className="flex gap-3 items-start">
                                                <Check className="h-4 w-4 text-[#C5A059] mt-1 shrink-0" />
                                                <span className="text-sm sm:text-base text-slate-700 leading-relaxed">
                                                    {d}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="lg:col-span-3 flex flex-col justify-between gap-8">
                                    <div>
                                        <p className="text-xs tracking-[0.25em] uppercase font-semibold text-[#1E3A8A] mb-4">
                                            The outcome
                                        </p>
                                        <p className="font-serif-accent italic text-lg text-slate-800 leading-relaxed">
                                            {s.outcome}
                                        </p>
                                    </div>
                                    <Link
                                        to={`/contact?intent=${encodeURIComponent(s.title)}`}
                                        data-testid={`service-cta-${s.slug}`}
                                        className="btn-sharp inline-flex items-center gap-2 text-xs font-bold tracking-[0.15em] uppercase text-[#0D131F]"
                                    >
                                        Discuss this <ArrowRight className="h-4 w-4 text-[#C5A059]" />
                                    </Link>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </section>

            <FinalCta />
        </main>
    );
};

export default Services;
